import i18n from '@dms/i18n';

import {MechanicalReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

interface NextReplacementMileageInputProps {
  name: MechanicalReplacementServiceIntervals;
}

/**
 * Numeric input component for displaying the calculated next replacement mileage of a vehicle component.
 * This field is typically calculated automatically based on the last replacement mileage and replacement interval.
 * Used in service interval tracking to show at what mileage a component should be replaced next.
 *
 * @param props.name - The component name (e.g., 'engineOil', 'gearboxOil', 'timingBelt')
 */
export function NextReplacementMileageInput(props: NextReplacementMileageInputProps) {
  return (
    <Field
      type="number"
      name={`serviceIntervals.${props.name}.nextReplacementMileage`}
      label={i18n.t('entity.vehicle.labels.nextReplacementMileage')}
      suffix={i18n.t('general.metric.km')}
    />
  );
}
